/* eslint-disable consistent-return */

import React, { useEffect } from "react";
import { useTranslations } from "next-intl";

import { Pagination } from "ui/pagination";
import { TeaserGrid } from "components/teaser-grid";
import { DefaultTeaser } from "components/teaser";
import { useTeaserTracking } from "modules/teaser-tracking";
import { ContainerBase } from "modules/DesignSystem/components/Container";
import { ProductList } from "resources/AudiotekaApi";
import { pathnamesKey } from "pathnames";

import css from "./product-grid.module.scss";

interface Props {
  listId: string;
  listName: string;
  products: ProductList;
  routeKey: keyof typeof pathnamesKey;
}

const ProductGrid = ({ listId, listName, products, routeKey }: Props) => {
  const productList = products._embedded?.["app:product"] || [];

  const t = useTranslations();

  const teaserTracking = useTeaserTracking();

  useEffect(() => {
    if (productList.length === 0) {
      return;
    }

    teaserTracking.addList(
      listId,
      productList.map((product) => product.id)
    );
    teaserTracking.updateObserver();

    return () => {
      teaserTracking.removeList(listId);
    };
  }, [listId, productList, teaserTracking]);

  return (
    <ContainerBase className={css.productGrid} extended full>
      {listName && <h1 className={css.title}>{listName}</h1>}
      <TeaserGrid
        listData={{ id: listId, name: listName }}
        products={productList}
        renderTeaser={(product) => <DefaultTeaser key={product.id} product={product} />}
      />
      {products.total === 0 && <h2 className={css.emptyList}>{t("product_grid.empty")}</h2>}
      <Pagination className={css.pagination} page={products.page} pages={products.pages} route={routeKey} />
    </ContainerBase>
  );
};

export default ProductGrid;
